import { Country } from "hooks";
import { ApiService } from "utils/requestService";

export const getCountries = () => ApiService.get<Country[]>("/settings/countries");
export const getWithStates = () => ApiService.get<string[]>("/settings/countries_with_states");
export const getHighRisk = () => ApiService.get<string[]>("/settings/high_risk_countries");
